export default [
  {
    description: 'GED Escrituração Escolar',
    path: '/ged/gedescrituracao',
    name: 'ged-escrituracao',
    component: () => import('@/views/ged/gedescrituracao/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Documento da Escrituração Escolar',
    parent: 'ged-escrituracao',
    path: '/ged/gedescrituracao/cadastro/:id?',
    name: 'ged-escrituracao-create',
    component: () => import('@/views/ged/gedescrituracao/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
];
